export enum E_CMS_ADDRESS_TYPE {
  BILLING = 'BILLING',
  SHIPPING = 'SHIPPING',
}

export enum E_CMS_MEDIUM_STATUS {
  pending = 'pending',
  processing = 'processing',
  processed = 'processed'
}

export enum E_CMS_VIDEO_PLATFORM {
  vimeo = 'vimeo',
  youtube = 'youtube',
}
